export default __webpack_public_path__ + "static/batman-f472393bc2126083a87dc02db92ba8fc.png";